// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Meta from 'vue-meta';

import VueHighcharts from 'vue-highcharts';
import Highcharts from 'highcharts/highstock';
import loadMap from 'highcharts/modules/map';
import loadMore from 'highcharts-more';

import App from './App';
import router from './router';
import store from './store';

import './router/auth';
import './components/common/global_components';
import './directives/focus';

// Highcharts Global Set Options
Highcharts.setOptions({
  // add license
  credits: {
    enabled: false,
  },
  yAxis: {
    title: { text: null },
    opposite: false,
  },
});

loadMap(Highcharts);
loadMore(Highcharts);

Vue.use(VueHighcharts, { Highcharts });

// https://laracasts.com/discuss/channels/vue/disable-you-are-running-vue-in-development-mode-warning
Vue.config.productionTip = false;

// Vue.use(VueHead);
Vue.use(Meta);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App,
  },
  store,
});

console.log('%c ★ Brand Master ★', 'font-size: 20px; background-color: #e89022; color: #ffffff; padding: 0 20px;');



// WEBPACK FOOTER //
// ./src/main.js